(function(){
  /******VIDEO REVIEWS SLIDER*******/

  const videoReviewSlider = new Swiper(".video--review--slider",{
    spaceBetween: 17,
    breakpoints: {
      320: {
        slidesPerView: 2.15
      },
      480: {
        slidesPerView: 2
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4.25
      }
    }
  })

  /*****ICON WITH TEXT SLIDER FUNCTIONALITY****/

  const iconWithTextSlider= new Swiper(".icon-with-text-slider",{
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTriggers = document.querySelectorAll("[playTrigger]");

if (playTriggers.length > 0) {
  playTriggers.forEach(function(trigger) {
    trigger.addEventListener("click", function() {
      // Pause all videos
      document.querySelectorAll("video").forEach(function(video) {
        video.pause();
      });

      // Show all video review contents and play triggers
      document.querySelectorAll(".video--review--content").forEach(function(content) {
        content.classList.remove("hidden");
      });

      playTriggers.forEach(function(trigger) {
        trigger.classList.remove("hidden");
      });

      // Play the clicked video
      const videoWrapper = this.closest("[videoWrapper]");
      videoWrapper.querySelector("video").play();
      videoWrapper.querySelector(".video--review--content").classList.add("hidden");

      // Hide the clicked play trigger
      this.classList.add("hidden");
    });
  });
}

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.closest("[videoWrapper]").querySelector(".video--review--content").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.closest("[videoWrapper]").querySelector(".video--review--content").classList.remove("hidden");
          this.load();
      })
    })
  }
})();